import React, { useState, useEffect, useMemo, useRef } from 'react';
import { object, func } from 'prop-types';
import { Tab, Tabs } from '../../common/TabCustom';

import { ALERT_TYPE, EMISION_DEFINICION_STATE, EMISION_EJECUCION_STATE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest, ServerRequestAsync } from '../../../utils/apiweb';
import { useFormErrors } from '../../hooks/useFormErrors';


import { FormError, Loading, InputEntidad, InputEjercicio, FormLabel } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { CloneObject } from '../../../utils/helpers';
import { getDateNow } from '../../../utils/convert';
import ProcedimientoParametrosGrid from '../../controls/ProcedimientoParametrosGrid';
import EmisionEjecucionCuotasGrid from '../../controls/EmisionEjecucionCuotasGrid';
import EmisionEjecucionCuentasGrid from '../../controls/EmisionEjecucionCuentasGrid';
import { isNull } from '../../../utils/validator';


const CuentaEmisionEjecucionForm = (props) => {

    //variables
    const today = getDateNow(false);

    const entityInit = {
        emisionDefinicion: {
            id: 0,
            idTipoTributo: 0,
            idNumeracion: 0,
            idProcedimiento: 0,
            idEstadoEmisionDefinicion: 0,
            idEmisionDefinicionBase: 0,
            idBoletaDefinicion: 0,
            numero: '',
            descripcion: '',
            codigoDelegacion: '',
            periodo: '',
            procesaPlanes: false,
            procesaRubros: false,
            procesaCarteles: false,
            procesaElementos: false,
            partidaUnificada: false,
            calculoMostradorWeb: false,
            calculoMasivo: false,
            calculoPagoAnticipado: false,
            fechaReliquidacionDesde: null,
            fechaReliquidacionHasta: null,
            modulo: ''
        },
        emisionEjecucion: {
            id: 0,
            idEmisionDefinicion: 0,
            idEstadoEmisionEjecucion: 0,
            idEmisionEjecucionAdelantada: 0,
            numero: '',
            descripcion: '',
            descripcionAbreviada: '',
            descripcionNotificacion: '',
            periodo: '',
            imprimeRecibosEmision: false,
            aplicaDebitoAutomatico: false,
            calculoMostradorWeb: false,
            calculoMasivo: false,
            calculoPrueba: false,
            calculoPagoAnticipado: false,
            fechaPagoAnticipadoVencimiento1: null,
            fechaPagoAnticipadoVencimiento2: null,
            fechaEjecucionInicio: null,
            fechaEjecucionFin: null,
            idOrdenamientoGeneral: 0,
            cuota: 0
        },
        emisionAprobacion: {
            id: 0,
            idEmisionEjecucion: 0,
            idEstadoProcesoInformeCalculo: 0,
            idUsuarioProcesoInformeCalculo: 0,
            fechaProcesoInformeCalculo: null,
            idEstadoProcesoControlRecibos: 0,
            idUsuarioProcesoControlRecibos: 0,
            fechaProcesoControlRecibos: null,
            idEstadoAprobacionCalculo: 0,
            idUsuarioAprobacionCalculo: 0,
            fechaAprobacionCalculo: null,
            idEstadoAprobacionControlRecibos: 0,
            idUsuarioAprobacionControlRecibos: 0,
            fechaAprobacionControlRecibos: null,
            idEstadoProcesoOrdenamiento: 0,
            idUsuarioProcesoOrdenamiento: null,
            fechaProcesoOrdenamiento: null,
            idEstadoProcesoInformeOrdenamiento: 0,
            idUsuarioProcesoInformeOrdenamiento: null,
            fechaProcesoInformeOrdenamiento: null,
            idEstadoAprobacionOrdenamiento: 0,
            idUsuarioAprobacionOrdenamiento: 0,
            fechaAprobacionOrdenamiento: null,
            idEstadoAprobacionCodigoBarras: 0,
            idUsuarioAprobacionCodigoBarras: 0,
            fechaAprobacionCodigoBarras: null,
            idEstadoProcesoCuentaCorriente: 0,
            idUsuarioProcesoCuentaCorriente: 0,
            fechaProcesoCuentaCorriente: null,
            idEstadoProcesoPublicacionDeuda: 0,
            idUsuarioProcesoPublicacionDeuda: 0,
            fechaProcesoPublicacionDeuda: null,
            idEstadoProcesoArchivoPublicacionDeuda: 0,
            idUsuarioProcesoArchivoPublicacionDeuda: null,
            fechaProcesoArchivoPublicacionDeuda: null,
            idEstadoProcesoImpresion: 0,
            idUsuarioProcesoImpresion: 0,
            fechaProcesoImpresion: null,
            idEstadoProcesoNotificacion: 0,
            idUsuarioProcesoNotificacion: 0,
            fechaProcesoNotificacion: null
        },
        procedimiento: {
            id: 0,
            nombre: '',
            descripcion: '',
            modulo: '',
            procedimientoParametros: [],
            procedimientoVariables: []
        },
        archivos: [],
        observaciones: [],
        etiquetas: [],
        funciones: [],
        emisionVariables: [],
        emisionProcedimientoParametros: [],
        emisionCuotas: [],
        emisionEjecucionCuotas: []
    };

    //refs
    const periodoRef = useRef(null);

    //hooks
    const [state, setState] = useState({
        idCuenta: 0,
        idTipoTributo: 0,
        loading: false,
        entity: entityInit,
        tabActive: "procedimiento"
    });

    const [listCuotas, setListCuotas] = useState([]);

    const [timestampUpdateVariables, setTimestampUpdateVariables] = useState(null);

    useEffect(() => {
        setTimeout(() => periodoRef.current?.focus(), 100);
    }, []);

    const mount = () => {
        if(props.data.idCuenta > 0) {
            setState(prevState => {
                return {...prevState,
                    idCuenta: props.data.idCuenta,
                    idTipoTributo: props.data.idTipoTributo,
                    entity: entityInit
                };
            });
        }
    }
    useEffect(mount, [props.data.idCuenta]);

    const [ emisionEjecucion_formValues, emisionEjecucion_formHandle, , emisionEjecucion_formSet ] = useForm({
        idEmisionDefinicion: 0,
        periodo: ''
    }, 'emisionEjecucion_');

    let listVariables = useMemo(() => 
        getListVariables(state.entity.emisionVariables, state.entity.procedimiento),
        [timestampUpdateVariables]);


    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickEjecutar = () => {
        if (!validate()) return;

        if (state.entity.emisionEjecucionCuotas.length === 0) {
            ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'Debe definir las cuotas de emisión');
            return;
        }

        AddEmisionEjecucion();
    };
    const handleClickConfirmar = () => {
        ConfirmEmisionEjecucion();
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }
    const callbackSuccessFindEmisionEjecucion = (response) => {
        response.json()
        .then((data) => {

            if (data.emisionEjecucion.fechaPagoAnticipadoVencimiento1) data.emisionEjecucion.fechaPagoAnticipadoVencimiento1 = new Date(data.emisionEjecucion.fechaPagoAnticipadoVencimiento1);
            if (data.emisionEjecucion.fechaPagoAnticipadoVencimiento2) data.emisionEjecucion.fechaPagoAnticipadoVencimiento2 = new Date(data.emisionEjecucion.fechaPagoAnticipadoVencimiento2);
            if (data.emisionEjecucion.fechaEjecucionInicio) data.emisionEjecucion.fechaEjecucionInicio = new Date(data.emisionEjecucion.fechaEjecucionInicio);
            if (data.emisionEjecucion.fechaEjecucionFin) data.emisionEjecucion.fechaEjecucionFin = new Date(data.emisionEjecucion.fechaEjecucionFin);

            if (data.emisionAprobacion.fechaProcesoInformeCalculo) data.emisionAprobacion.fechaProcesoInformeCalculo = new Date(data.emisionAprobacion.fechaProcesoInformeCalculo);
            if (data.emisionAprobacion.fechaProcesoControlRecibos) data.emisionAprobacion.fechaProcesoControlRecibos = new Date(data.emisionAprobacion.fechaProcesoControlRecibos);
            if (data.emisionAprobacion.fechaAprobacionCalculo) data.emisionAprobacion.fechaAprobacionCalculo = new Date(data.emisionAprobacion.fechaAprobacionCalculo);
            if (data.emisionAprobacion.fechaAprobacionControlRecibos) data.emisionAprobacion.fechaAprobacionControlRecibos = new Date(data.emisionAprobacion.fechaAprobacionControlRecibos);
            if (data.emisionAprobacion.fechaProcesoOrdenamiento) data.emisionAprobacion.fechaProcesoOrdenamiento = new Date(data.emisionAprobacion.fechaProcesoOrdenamiento);
            if (data.emisionAprobacion.fechaProcesoInformeOrdenamiento) data.emisionAprobacion.fechaProcesoInformeOrdenamiento = new Date(data.emisionAprobacion.fechaProcesoInformeOrdenamiento);
            if (data.emisionAprobacion.fechaAprobacionOrdenamiento) data.emisionAprobacion.fechaAprobacionOrdenamiento = new Date(data.emisionAprobacion.fechaAprobacionOrdenamiento);
            if (data.emisionAprobacion.fechaAprobacionCodigoBarras) data.emisionAprobacion.fechaAprobacionCodigoBarras = new Date(data.emisionAprobacion.fechaAprobacionCodigoBarras);
            if (data.emisionAprobacion.fechaProcesoCuentaCorriente) data.emisionAprobacion.fechaProcesoCuentaCorriente = new Date(data.emisionAprobacion.fechaProcesoCuentaCorriente);
            if (data.emisionAprobacion.fechaProcesoArchivoPublicacionDeuda) data.emisionAprobacion.fechaProcesoArchivoPublicacionDeuda = new Date(data.emisionAprobacion.fechaProcesoArchivoPublicacionDeuda);
            if (data.emisionAprobacion.fechaProcesoImpresion) data.emisionAprobacion.fechaProcesoImpresion = new Date(data.emisionAprobacion.fechaProcesoImpresion);
            if (data.emisionAprobacion.fechaProcesoNotificacion) data.emisionAprobacion.fechaProcesoNotificacion = new Date(data.emisionAprobacion.fechaProcesoNotificacion);

            data.emisionEjecucionCuotas.forEach(x => {
                if (x.fechaVencimiento1) x.fechaVencimiento1 = new Date(x.fechaVencimiento1);
                if (x.fechaVencimiento2) x.fechaVencimiento2 = new Date(x.fechaVencimiento2);
                if (x.fechaVencimiento1Original) x.fechaVencimiento1Original = new Date(x.fechaVencimiento1Original);
                if (x.fechaVencimiento2Original) x.fechaVencimiento2Original = new Date(x.fechaVencimiento2Original);
                if (x.fechaVencimiento1Prorroga) x.fechaVencimiento1Prorroga = new Date(x.fechaVencimiento1Prorroga);
                if (x.fechaVencimiento2Prorroga) x.fechaVencimiento2Prorroga = new Date(x.fechaVencimiento2Prorroga);
            });

            data.archivos.forEach(x => {
                if (x.fecha) x.fecha = new Date(x.fecha);
            });
            data.observaciones.forEach(x => {
                if (x.fecha) x.fecha = new Date(x.fecha);
            });

            setListCuotas([]);
            setState(prevState => {
                return {...prevState, loading: false, entity: data};
            });
            emisionEjecucion_formSet({
                idEmisionDefinicion: data.emisionEjecucion.idEmisionDefinicion,
                periodo: data.emisionEjecucion.periodo
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackSuccessFindEmisionDefinicion = async (responseDefinicionEmision, responseProcedimiento) => {
        try {
            const dataDefinicionEmision = await responseDefinicionEmision.json();
            const dataProcedimiento = await responseProcedimiento.json();

            let index = 0;
            let entity = CloneObject(state.entity);
            const procesaRubros = dataDefinicionEmision.emisionDefinicion.procesaRubros;
            entity.emisionDefinicion = dataDefinicionEmision.emisionDefinicion;
            entity.emisionVariables = dataDefinicionEmision.emisionVariables;
            entity.procedimiento = dataProcedimiento;
            entity.emisionProcedimientoParametros = dataProcedimiento.procedimientoParametros.map(parametro => {
                return {
                    id: --index,
                    idEmisionEjecucion: 0,
                    idProcedimientoParametro: parametro.id,
                    valor: parametro.valorPredeterminado
                };
            });
            entity.emisionEjecucionCuotas = dataDefinicionEmision.emisionCuotas.map((cuota, index) => {
                return {...cuota,
                    fechaVencimiento1: new Date(cuota.fechaVencimiento1),
                    fechaVencimiento2: new Date(cuota.fechaVencimiento2),
                    fechaVencimiento1Original: new Date(cuota.fechaVencimiento1),
                    fechaVencimiento2Original: new Date(cuota.fechaVencimiento2),
                    id: index+1,
                    idEmisionEjecucion: 0,
                    orden: index+1,
                    state: 'a'
                };
            });
            setListCuotas(dataDefinicionEmision.emisionCuotas);
            setState(prevState => {
                return {...prevState, loading: false, entity: entity};
            });
            setTimestampUpdateVariables(new Date());
        }
        catch(error) {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        }
    };

    //funciones
    function getListVariables(emisionVariables, procedimiento) {
        return (procedimiento)
                ? procedimiento.procedimientoVariables
                    .filter(f => emisionVariables.map(x => x.idProcedimientoVariable).includes(f.id))
                    .sort((a, b) => a.orden - b.orden)
                : [];
    }

    function getErrors() {

        const errors = {};

        if (emisionEjecucion_formValues.idEmisionDefinicion === 0) errors.idEmisionDefinicion = VALIDATION_MESSAGE.REQUIRED_OPTION;

        return errors;
    }

    function FindEmisionDefinicion(idEmisionDefinicion) {
        
        setState(prevState => {
            return {...prevState, loading: true};
        });

        const requests = [];
        requests.push(ServerRequestAsync(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.EMISION_DEFINICION,
            `/${idEmisionDefinicion}`,
            null
        ));
        requests.push(ServerRequestAsync(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.PROCEDIMIENTO,
            `/emision-definicion/${idEmisionDefinicion}`,
            null
        ));

        Promise.all(requests)
        .then(responses => {
            const responseDefinicionEmision = responses[0];
            const responseProcedimiento = responses[1];

            if (!responseDefinicionEmision.ok) {
                callbackNoSuccess(responseDefinicionEmision);
                return;
            }
            if (!responseProcedimiento.ok) {
                callbackNoSuccess(responseProcedimiento);
                return;
            }

            callbackSuccessFindEmisionDefinicion(responseDefinicionEmision, responseProcedimiento);
        })
        .catch(callbackError);
    }

    function CleanDefinicionEmision () {
        let entity = CloneObject(state.entity);
        entity.procedimiento = entityInit.procedimiento;
        entity.emisionVariables = [];
        entity.emisionProcedimientoParametros = [];
        setState(prevState => {
            return {...prevState, loading: false, entity: entity};
        });
    }

    function AddEmisionEjecucion() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            callbackSuccessFindEmisionEjecucion(response);
            ShowToastMessage(ALERT_TYPE.ALERT_INFO, "Emisión ejecutada correctamente. Deberá confirmar para impactar los datos en la cuenta corriente", () => {
                SetTabActive("resultadoCuenta");
            });
        };

        const dataBody = {
            idCuenta: state.idCuenta,
            emisionEjecucion: {
                ...entityInit,
                emisionEjecucion: {
                    ...state.entity.emisionEjecucion,
                    idEmisionDefinicion: parseInt(emisionEjecucion_formValues.idEmisionDefinicion),
                    periodo: emisionEjecucion_formValues.periodo
                },
                emisionProcedimientoParametros: state.entity.emisionProcedimientoParametros,
                emisionEjecucionCuotas: state.entity.emisionEjecucionCuotas
            }
        };

        const paramsUrl = `/liquidacion`;

        ServerRequest(
            REQUEST_METHOD.POST,
            null,
            true,
            APIS.URLS.EMISION_EJECUCION,
            paramsUrl,
            dataBody,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }

    function ConfirmEmisionEjecucion() {

        setState(prevState => {
            return {...prevState, loading: true};
        });

        const callbackSuccess = (response) => {
            ShowToastMessage(ALERT_TYPE.ALERT_SUCCESS, "Emisión confirmada correctamente. Los VEPs podrán ser emitidos desde la cuenta corriente", () => {
                props.onDismiss();
            });
        };

        const paramsUrl = `/${state.entity.emisionAprobacion.id}/AprobacionCalculo`;

        ServerRequest(
            REQUEST_METHOD.PUT,
            null,
            true,
            APIS.URLS.EMISION_APROBACION,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );

    }
    
    function UpdateEntity(typeEntity, row) {
        let entity = CloneObject(state.entity);

        if (typeEntity === 'EmisionEjecucionCuota') {
            if (row.state === 'a') {
                entity.emisionEjecucionCuotas.push(row);
            }
            else if (row.state === 'm') {
                const index = entity.emisionEjecucionCuotas.indexOf(entity.emisionEjecucionCuotas.find(x => x.id === row.id));
                if (index !== -1) {
                    row.state = 'a'; //originalmente era un alta
                    entity.emisionEjecucionCuotas[index] = row;
                }
            }
            else if (row.state === 'r') {
                entity.emisionEjecucionCuotas = entity.emisionEjecucionCuotas.filter(f => f.id !== row.id);
            }
        }

        setState(prevState => {
            return {...prevState,
                entity: entity
            };
        });
    }

    function UpdateEmisionProcedimientoParametro(rows) {
        let entity = CloneObject(state.entity);

        rows.forEach(row => {
            const index = entity.emisionProcedimientoParametros.indexOf(entity.emisionProcedimientoParametros.find(x => x.id === row.id));
            if (index !== -1) {
                entity.emisionProcedimientoParametros[index] = row;
            }
        });

        setState(prevState => {
            return {...prevState,
                entity: entity
            };
        });
    }

    function SetTabActive(tab) {
        setState(prevState => {
            return {...prevState, tabActive: tab};
        });
    }

    return (
    <>

        <Loading visible={state.loading}></Loading>

        <div className="m-top-10 m-bottom-10">

            <div className=' i-disabled'>
                <div className='row'>
                    <div className="col-12">
                        <div className='accordion-header-title'>
                            <h2 className='form-label m-top-10 m-bottom-20'>Selección de emisión</h2>
                        </div>
                    </div>
                </div>
            </div>
           
                <div className='row form-basic'>
                    <div className="col-12 col-lg-2">
                        <label htmlFor="emisionEjecucion_periodo" className="form-label">Período</label>
                        <InputEjercicio
                            ref={periodoRef}
                            name="emisionEjecucion_periodo"
                            placeholder=""
                            className="form-control"
                            value={ emisionEjecucion_formValues.periodo }
                            onChange={ emisionEjecucion_formHandle }
                            disabled={emisionEjecucion_formValues.idEmisionDefinicion > 0}
                        />
                    </div>
                    <div className="col-12 col-lg-7">
                        <FormLabel htmlFor="emisionEjecucion_idEmisionDefinicion" required>Definición de emisión</FormLabel>
                        <InputEntidad
                            name="emisionEjecucion_idEmisionDefinicion"
                            title="Definición de emisiones"
                            placeholder=""
                            className={`form-control ${errorOf('idEmisionDefinicion') ? 'is-invalid' : ''}`}
                            value={ emisionEjecucion_formValues.idEmisionDefinicion }
                            onChange={(event) => {
                                const {target} = event;
                                let idEmisionDefinicion = 0;
                                if (target.value > 0) {
                                    idEmisionDefinicion = target.row.id;
                                    FindEmisionDefinicion(idEmisionDefinicion);
                                }
                                else {
                                    CleanDefinicionEmision();
                                }
                                emisionEjecucion_formSet({...emisionEjecucion_formValues,
                                    idEmisionDefinicion: idEmisionDefinicion
                                });
                            }}
                            entidad="EmisionDefinicion"
                            onFormat={(row) => (row && row.id) ? `${row.numero} - ${row.descripcion}` : ''}
                            columns={[
                                { Header: 'Número', accessor: 'numero', width: '20%' },
                                { Header: 'Descripción', accessor: 'descripcion', width: '80%' },
                            ]}
                            filter={(row) => {
                                if (row.fechaReliquidacionDesde) row.fechaReliquidacionDesde = new Date(row.fechaReliquidacionDesde);
                                if (row.fechaReliquidacionHasta) row.fechaReliquidacionHasta = new Date(row.fechaReliquidacionHasta);
                                return (row.calculoMostradorWeb &&
                                        row.periodo === emisionEjecucion_formValues.periodo &&
                                        row.idTipoTributo === state.idTipoTributo &&
                                        row.idEstadoEmisionDefinicion === EMISION_DEFINICION_STATE.ACTIVA &&
                                        (isNull(row.fechaReliquidacionDesde) || row.fechaReliquidacionDesde <= today ) &&
                                        (isNull(row.fechaReliquidacionHasta) || row.fechaReliquidacionHasta >= today ))
                            }}
                            disabled={(emisionEjecucion_formValues.periodo.length === 0 || state.entity.emisionEjecucion.id !== 0)}
                        />
                        <FormError message={errorOf('idEmisionDefinicion')} />
                    </div>
                    {(emisionEjecucion_formValues.idEmisionDefinicion > 0) &&
                    <div className="col-12 col-lg-3 m-top-33">
                        {(state.entity.emisionEjecucion.id === 0) ?
                        <button className="btn action-button" onClick={ (event) => handleClickEjecutar() }>Ejecutar emisión</button>
                        :
                        <button className="btn action-button" onClick={ (event) => handleClickConfirmar() }>Confirmar emisión</button>
                        }
                    </div>
                    }
                </div>
            

            <div className={(emisionEjecucion_formValues.idEmisionDefinicion === 0) ? 'invisible' : ''}>
                <Tabs
                    id="tabs-emision-ejecucion"
                    activeKey={state.tabActive}
                    className="m-top-20"
                    onSelect={(tab) => SetTabActive(tab)}
                >
                    <Tab eventKey="procedimiento" title="Procedimiento">
                        <div className='tab-panel'>
                            <div className='row form-basic'>
                                <div className="col-12 col-lg-10 m-bottom-20">
                                    <label htmlFor="emisionEjecucion_idProcedimiento" className="form-label">Procedimiento</label>
                                    <InputEntidad
                                        name="emisionEjecucion_idProcedimiento"
                                        placeholder=""
                                        className="form-control"
                                        value={ state.entity.procedimiento.id }
                                        disabled={true}
                                        entidad="Procedimiento"
                                        onFormat={(row) => (row && row.id) ? `${row.nombre} - ${row.descripcion}` : ''}
                                    />
                                </div>
                                <div className="col-12">
                                    <ProcedimientoParametrosGrid
                                        disabled={(state.entity.emisionEjecucion.id !== 0)}
                                        showValue={true}
                                        showPagination={true}
                                        data={{
                                            idEmisionEjecucion: state.entity.emisionEjecucion.id,
                                            listParametros: (state.entity.procedimiento.id > 0)
                                                            ? state.entity.procedimiento.procedimientoParametros
                                                            : [],
                                            listValores: state.entity.emisionProcedimientoParametros
                                        }}
                                        onChange={(typeEntity, rows) => UpdateEmisionProcedimientoParametro(rows)}
                                    />
                                </div>
                            </div>
                        </div>
                    </Tab>
                    <Tab eventKey="cuotas" title="Cuotas" tabClassName={(state.mode !== OPERATION_MODE.NEW) ? '' : 'invisible'}>
                        <div className='tab-panel'>
                            <EmisionEjecucionCuotasGrid
                                disabled={(state.entity.emisionEjecucion.id !== 0)}
                                requireConfirmRemove={false}
                                modeOnlySelector={true}
                                data={{
                                    idEmisionEjecucion: state.entity.emisionEjecucion.id,
                                    periodo: state.entity.emisionDefinicion.periodo,
                                    listCuotas: listCuotas,
                                    listEjecucionCuotas: state.entity.emisionEjecucionCuotas,
                                    listVariables: listVariables,
                                    listFunciones: state.entity.funciones,
                                    fechaVencimiento1: null,
                                    fechaVencimiento2: null
                                }}
                                periodo={state.entity.emisionDefinicion.periodo}
                                procesaRubros={state.entity.emisionDefinicion.procesaRubros}
                                onChange={(typeEntity, row) => UpdateEntity(typeEntity, row)}
                            />
                        </div>
                    </Tab>
                    <Tab eventKey="resultadoCuenta" title="Resultados por cuenta" tabClassName={(state.mode !== OPERATION_MODE.NEW && state.entity.emisionEjecucion.idEstadoEmisionEjecucion === EMISION_EJECUCION_STATE.FINALIZADA) ? '' : 'invisible'}>
                        <div className='tab-panel'>
                            <EmisionEjecucionCuentasGrid
                                disabled={true}
                                data={{
                                    idCuenta: state.idCuenta,
                                    idTipoTributo: state.entity.emisionDefinicion.idTipoTributo,
                                    emisionDefinicion: state.entity.emisionDefinicion,
                                    emisionEjecucion: state.entity.emisionEjecucion
                                }}
                                onChange={(typeEntity, row) => {}}
                            />
                        </div>
                    </Tab>
                </Tabs>
            </div>

        </div>

    </>
    )
}

CuentaEmisionEjecucionForm.propTypes = {
    data: object.isRequired,
    onDismiss: func.isRequired
  };

export default CuentaEmisionEjecucionForm;